import React, { useContext, useState, useRef, useEffect } from 'react';
import useOnScreen from '../../hooks/useOnScreen';
import { Link } from 'react-router-dom';

function Producto({ data }) {
  const [show, setShow] = useState(false);
  const ref = useRef(null);
  const isVisible = useOnScreen(ref);
  useEffect(() => {
    if (isVisible && !show) {
      setShow(true);
    }
  }, [isVisible]);
  return (
    <div
      ref={ref}
      className={`pb-4 basis-1/3 md:basis-1/5 transition-all relative duration-500 ease-in delay-400 ${
        show ? 'translate-y-0 opacity-100' : 'translate-y-1/4 opacity-0'
      }`}
    >
      <div className="relative h-auto">
        <img
          className="transition-transform duration-500 hover:scale-110"
          src={require(`../../assets/images/productos/${data.codigo}/0.jpg`)}
        />
        <div className="hover:opacity-100 hover top-0 right-0 w-full h-full bg-black/60 opacity-0 absolute">
          <div className="w-full h-full relative">
            <div className="flex h-full w-2/3 m-auto text-center flex-col items-center md:justify-center justify-start md:pt-0 pt-4">
              <p className="text-white md:text-lg text-sm font-bold">
                {data.codigo}
              </p>
              <p className="text-gray-200 md:text-base text-xs">
                {data.nombre}
              </p>
            </div>
            <div className="absolute bottom-0 right-0 h-1/3 w-full bg-[#333] flex items-center justify-center">
              <Link className="w-2/3" to={`/producto/${data.codigo}`}>
                <button className="p-2 bg-white border md:text-base text-xs border-solid border-gray-200 rounded-lg w-full h-1/3 m-auto">
                  Ver Más
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <p className="text-center w-5/6 md:text-base text-sm m-auto py-2">
        <span className="text-gray-400 text-xs block">{data.codigo}</span>
        {data.nombre}
      </p>
    </div>
  );
}
export default Producto;
